module.exports = __webpack_public_path__ + "static/media/edit.edd5ac5b.svg";